import { render, staticRenderFns } from "./PCHomeView.vue?vue&type=template&id=840e9978&scoped=true&"
import script from "./PCHomeView.vue?vue&type=script&lang=js&"
export * from "./PCHomeView.vue?vue&type=script&lang=js&"
import style0 from "./PCHomeView.vue?vue&type=style&index=0&id=840e9978&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840e9978",
  null
  
)

export default component.exports